import React, { Component } from 'react';
import autobind from 'react-autobind'
import Dropzone from 'react-dropzone';
import { ClipLoader } from 'react-spinners'
import _ from 'lodash'
import ErrorHelper from '../ErrorHelper';
import { convertMinutesToText } from "../../lib/utils";

function mergeFileLists(oldModelFiles, newRawFiles)
{
    const files = []
    oldModelFiles.forEach((oldFile) => {
        if (!oldFile.error) {
            files.push(oldFile)
        }
        else {
            const file = Object.assign({}, oldFile);
            delete file.error
            files.push(file);
        }
    })
    newRawFiles.forEach((rawFile) => {
        const index = files.findIndex(file => file.originalname === rawFile.name)
        if (index === -1) {
            files.push({ originalname:rawFile.name, file:rawFile })
        }
        else {
            const file = files[index];
            const fileWithError = Object.assign({}, file, { 
                error: "Failed to add file with same name." })
            files[index] = fileWithError
        }
    })
    return files
}

function renderErrors(errors) {
    if (!errors) return {}
    return <div className="items-list-error"> {
        errors.map(error => {
            var text = "Undetermined error"
            if (_.isString(error)) text = error
            if (error && error.description) text = error.description
            return <div>{text}</div>
        })
    }</div>
}

function filterErrors(errors, key) {
    if (!errors) return []
    return errors.filter(error => {
        return error.reference === key
    })
}

export default class ModelFileDrop extends Component {

    constructor(props) {
      super(props)
      autobind(this)
    }

    render () {
        const { files : propsFiles, errors, conversionStarted, conversionsBefore, modelInvalid, onChange, parentValidation, disabled } = this.props
        const files = propsFiles ? propsFiles : [];

        const { touched, error } = parentValidation;
        let modelError = !error && modelInvalid ? {errorKeys : { 'modelFiles' : ['Invalid Model'] }} : error;
        return (
            <div className="panel mb-1">
                <div className="panel-body p-4">
                    <div className={`items-list-background p-0 ${ErrorHelper.getValidationErrorClass("modelFiles", modelError, touched)}`}>
                        <div className="px-4 pt-4 pb-0">
                            <div className="items-list items-list--models m-0">
                                { renderErrors(filterErrors(errors, undefined)) }
                                {
                                    files.filter(file => file).map((file, index) => 
                                        <div className="items-list-item" key={ index }>
                                            <span className="list-item-1">{ file.originalname }</span>
                                            <span className="list-item-2">{ 
                                                renderErrors([
                                                    ...(file.error ? [file.error] : []), 
                                                    ...filterErrors(errors, file._id)]) 
                                            }</span>
                                            { file.path ? [] : <span className="list-item-5">new</span> }
                                            <span className="list-item-actions list-item-6"> 
                                                <span className="ar-icon s7-trash"
                                                    onClick={()=> {if (!disabled && !conversionStarted) onChange(files.slice(0, index).concat(files.slice(index + 1)))}}/>
                                            </span>
                                        </div>)
                                }
                            </div>
                        </div>
                        <Dropzone
                            multiple={true}
                            onDropAccepted={ (newRawFiles) => onChange(mergeFileLists(files, newRawFiles)) }
                            className="btn btn-block mx-auto p-6"
                            disabled={disabled || !!conversionStarted}>
                            <span>Click or drag graphic resources here</span>

                        </Dropzone>
                    </div>
                </div>
                { !conversionStarted || modelInvalid ? [] : <div className="px-4">
                    <ClipLoader
                        color={'#2CC185'}
                        loading={true}
                        className=""
                        disabled={disabled}
                    />
                    <span className="m-4 align-middle">Conversion started at { new Date(conversionStarted).toLocaleString() }. 
                        This is a background task. It is safe to navigate away.
                    </span>
                </div>}
                { conversionsBefore > 0 &&
                    <span className="m-4 align-middle">Your conversion will start in about <b>{convertMinutesToText(conversionsBefore * 8)}</b>
                    </span>
                }
                { modelInvalid &&
                    <p className="m-4 align-middle text-danger">
                        Your 3D model is not compatible with our platform.
                        Please upload a NEW .obj, .fbx, .gltf properly configured for real time rendering.
                    </p>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Files/ModelFileDrop.js